module.exports = __webpack_public_path__ + "static/media/NP.6e16ca4c.svg";